module.exports = __webpack_public_path__ + "static/media/Sam_banner.af267823.jpg";